@if (navbarData.hasValue()) {
    <nav
        class="z-10 lg:place-items-center lg:grid grid-cols-[max-content_1fr_max-content] mx-auto p-6 w-full"
        [ngClass]="[
            slugService.isHome()
                ? 'absolute'
                : 'relative bg-neutral-800 ~mb-8/24 shadow-lg',
        ]"
        #navbar
    >
        <!-- logo + hamburger -->
        <div class="flex justify-between items-center gap-4">
            <a
                class="flex flex-shrink-0 items-center hover:scale-105 transition-transform cursor-pointer"
                [routerLink]="[
                    '/',
                    languageService.getLanguageCode,
                    'apartment',
                ]"
                aria-label="zehentmoar"
            >
                <img
                    class="w-auto h-24"
                    src="{{ navbarData.value()!.data.logo.url }}"
                    alt="zehentmoar logo"
                />
            </a>
            <div class="lg:hidden block">
                <a
                    [routerLink]="[
                        '/',
                        this.languageService.getLanguageCode,
                        'apartment',
                        'buchen',
                    ]"
                    class="z-10 flex px-6 font-semibold ~py-8/12"
                    ><app-button>{{ "footer.book" | translate }}</app-button></a
                >
            </div>
            <div class="lg:hidden">
                <button
                    type="button"
                    class="hs-collapse-toggle relative flex justify-center items-center gap-x-2 bg-white hover:bg-gray-50 focus:bg-gray-300 disabled:opacity-50 shadow-2xs border border-gray-700 rounded-lg focus:outline-hidden size-9 text-gray-800 disabled:pointer-events-none"
                    id="hs-navbar-example-collapse"
                    aria-expanded="false"
                    aria-controls="hs-navbar-example"
                    aria-label="Toggle navigation"
                    data-hs-collapse="#hs-navbar-example"
                >
                    <svg
                        class="hs-collapse-open:hidden size-4 shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="3" x2="21" y1="6" y2="6" />
                        <line x1="3" x2="21" y1="12" y2="12" />
                        <line x1="3" x2="21" y1="18" y2="18" />
                    </svg>
                    <svg
                        class="hidden hs-collapse-open:block size-4 shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                    <span class="sr-only">Toggle navigation</span>
                </button>
            </div>
        </div>

        <!-- items -->
        <app-navbar-items
            class="text-white"
            [navbarItems]="navbarData.value().data.navbarItems"
            page="apartment"
        ></app-navbar-items>

        <!-- language + social media + booking -->
        <div
            class="hidden lg:flex justify-center justify-self-end items-center gap-4"
        >
            <app-language-selection [isMinimal]="true"></app-language-selection>
            <app-social-media-links
                class="flex fill-white"
            ></app-social-media-links>
            <div class="hidden lg:block">
                <a
                    [routerLink]="[
                        '/',
                        this.languageService.getLanguageCode,
                        'apartment',
                        'buchen',
                    ]"
                    ><app-button>
                        {{ "footer.book" | translate }}
                    </app-button></a
                >
            </div>
        </div>
    </nav>
}
